var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{attrs:{"shadow":"hover"}},[_c('label',{attrs:{"slot":"header"},slot:"header"},[_vm._v("快速切换栏")]),_vm._v(" 依赖store.js中的JMenu模块 "),_c('el-divider',{attrs:{"content-position":"left"}},[_vm._v("j-quick-tab")]),_c('j-quick-tab')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }